//Get the value of a given cookie
export const getCookieValue = name => `; ${document.cookie}`.split(`; ${name}=`).pop().split(';').shift();